import { DataBean } from "../../DataBean";


export class HealthIDTypes extends DataBean {

    public async getHealthIDTypes(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthIDTypes_Number", [args]);
    }

}